module.exports = ".error-container {\n  position: absolute; }\n  .error-container .card .card-header {\n    border-radius: 50%;\n    font-size: 36px;\n    height: 80px;\n    margin: 0 auto;\n    margin-top: -40px;\n    width: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/not-found/not-found.component.scss
// module id = ./src/app/pages/errors/not-found/not-found.component.scss
// module chunks = main